import * as types from "../../constants/actionTypes";

const initState = {
    isLoading: false,
    listKonsultasi:[],
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.DASHBOARD_DOKTER_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.GET_LIST_KONSULTASI_SUCCESS: {
            return {
              ...state,
              listKonsultasi : action.value
            }
        }
        default:
            return {
                ...state
            }
    }
}  